var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.58 13.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pastinha_branca") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.12,1.17H4.48c1.45,0,1.18,0,2.28,1.08,1.58,1.58,3,1.16,5.56,1.16V4h1.12c0-2.14-1-1.68-3.71-1.68-2.34,0-1.88-1.15-3.46-2C5.56-.09,2.15,0,1.12.05S0,.73,0,1.66V9.77c0,4.43,0,3.71,7.13,3.71.91,0,4.9,0,5.45,0a2.27,2.27,0,0,0,1.62-1c.53-.84.34-4,.34-5.11,0-.78.17-1.92-.3-2.43S12.8,4.53,12,4.53H3.77c-2,0-1.53,1.26-1.53,3.85v2.73c0,.42.06.9-.21,1.12A.56.56,0,0,1,1.15,12c-.16-.52,0-9.47,0-10.81Z",
    transform: "translate(-0.01 0)",
    fill: "#131f30",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder_icon.47b50a58d58bd38b7992382a66bb15f1.svg";
export { ForwardRef as ReactComponent };